import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CloseWorkOrderInput, ClosedWorkOrder } from "../type/WorkOrder";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { GET_WORK_ORDERS_FETCH_KEY } from "./useGetWorkOrder";

export const closeWorkOrder = async (
  id: string,
  data: CloseWorkOrderInput,
): Promise<ClosedWorkOrder> => {
  const response = await fetcher.post<ClosedWorkOrder>(
    `${API.GESLUB}/workOrders/${id}/close`,
    data,
  );
  return response.data;
};

export const useCloseWorkOrder = () => {
  const queryClient = useQueryClient();

  return useMutation<
    ClosedWorkOrder,
    Error,
    { id: string; data: CloseWorkOrderInput }
  >({
    mutationFn: ({ id, data }) => closeWorkOrder(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_WORK_ORDERS_FETCH_KEY],
      });
    },
  });
};
